import { Component } from '@angular/core';
import { CellViewBase } from '../base';

@Component({
    selector: 'fi-checklist-report-view-checkpoints-per-unit-table-cell-view-array',
    templateUrl: './array.component.html',
    standalone: false,
})
export class ArrayComponent extends CellViewBase {}
